import { OperationEntityDetailDto } from '@/api/backoffice/clients';

export const copyOperationEntityValues = (from: OperationEntityDetailDto, to: OperationEntityDetailDto) => {
    if (from?.id === to?.id) {
        to.code = from.code;
        to.label = from.label;
        to.description = from.description;
        to.crs = from.crs;
        to.model = from.model;
    }
};
